import { render, staticRenderFns } from "./Fund-new-flow.vue?vue&type=template&id=082da83e&"
import script from "./Fund-new-flow.vue?vue&type=script&lang=js&"
export * from "./Fund-new-flow.vue?vue&type=script&lang=js&"
import style0 from "./Fund-new-flow.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.9.6_kq6vcxhoovkpo5ecbydii27d4a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports